import { GET_LIST_FOR_PRODUCT } from 'src/redux/Actions/Type';

const initialState = {
  products: {},
};

const productReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case GET_LIST_FOR_PRODUCT:
      return {
        ...state,
        products: payload,
      };
    default:
      return state;
  }
};
export default productReducer;
